export default class ExportTool {

	constructor(...args) {
		console.log(args)
		const {
			fileUrl, // 文件URL
			fileName = "", // 需要导出的文件名
			fileFormat = ".xls", // 文件格式
			alert = window.alert
		} = args[0];
		this.fileUrl = fileUrl;
		this.fileName = fileName;
		this.fileFormat = fileFormat;
		this.alert = alert;
		// Object.assign(this, args[0])
	}

	// 文件地址导出
	getUrl() {
		if(!this.fileUrl) {
			this.alert("缺少文件URL");
			return false;
		}
		try {
			let instance = document.createElement('a')
			instance.href = this.fileUrl;
			//配置下载的文件名
			instance.download = `${this.fileName}${this.fileFormat}`;
			instance.click();
//			this.alert("导出成功");
		} catch(error) {
			console.log(error)
			this.alert("导出失败");
		}
	}

	// 文件流导出
	getBlob() {
		if(!this.fileUrl) {
			this.alert("缺少文件URL");
			return false;
		}
		try {
			let blob = new Blob([this.fileUrl], {
				type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
			});
			let instance = document.createElement('a')
			instance.href = window.URL.createObjectURL(blob)
			//配置下载的文件名
			instance.download = `${this.fileName}${this.fileFormat}`;
			instance.click()
//			this.alert("导出成功");
		} catch(error) {
			console.log(error)
			this.alert("导出失败");
		}
	}

}